import { useApiClient } from '@portals-platform/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ENDPOINTS } from '../api/endpoints.js';
import { queryKeys } from '../query-keys.js';

export function useDeleteCertificate() {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: async (certificateId) => {
      await client.delete(ENDPOINTS.certificate(certificateId));
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.certificates() }),
  });
}
